import { TextField, Theme } from '@mui/material';
import { useState, FC, ChangeEvent, FocusEvent } from 'react';
import {
    IconButton,
    InputAdornment,
    FormControl,
    VisibilityIcon,
    VisibilityOffIcon,
    createStyles,
    makeStyles
} from '../uiLibraryImports';
import { PasswordTypes } from './passwordTypes';
import './password.scss';

const Password: FC<PasswordTypes> = (props: PasswordTypes) => {
    const {
        password,
        onChangePassword,
        error,
        errorMessage,
        onBlur,
        id,
        autoComplete = 'on',
        helperTextAlign = 'right',
        helperText
    } = props;
    const [showPassword, setShowPassword] = useState<Boolean>(false);

    const useStyles = makeStyles((_: Theme) =>
        createStyles({
            cssOutlinedInput: {
                height: '2.75rem !important',
                width: '100% !important',
                background: 'rgba(38, 35, 58, 0.5)',
                color: 'white',
                '&$cssFocused $notchedOutline': {
                    borderColor: 'rgba(71, 154, 235, 1) !important'
                }
            },
            cssFocused: {},
            notchedOutline: {
                borderColor: error ? 'rgba(241, 96, 93, 1) !important' : 'rgba(255, 255, 255, 0.25) !important'
            },
            helperText: {
                textAlign: helperTextAlign,
                marginRight: 0,
                color: error ? 'rgba(241, 96, 93, 1) !important' : 'rgba(255, 255, 255, 0.50) !important',
                marginLeft: '0 !important'
            }
        })
    );

    const classes = useStyles();

    const handleClickShowPassword = () => {
        setShowPassword(!showPassword);
    };

    const handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();
    };

    return (
        <FormControl variant="outlined">
            <TextField
                id={id}
                className="password"
                type={showPassword ? 'text' : 'password'}
                value={password}
                error={error}
                helperText={errorMessage || helperText}
                onChange={(e: ChangeEvent<HTMLInputElement>): void =>
                    onChangePassword && onChangePassword(e.target.value)
                }
                onBlur={(e: FocusEvent<HTMLInputElement>): void => onBlur && onBlur(e.target.value)}
                FormHelperTextProps={{
                    className: classes.helperText
                }}
                variant="outlined"
                InputProps={{
                    autoComplete,
                    classes: {
                        root: classes.cssOutlinedInput,
                        focused: classes.cssFocused,
                        notchedOutline: classes.notchedOutline
                    },
                    endAdornment: (
                        <InputAdornment position="end">
                            <IconButton
                                aria-label="toggle password visibility"
                                onClick={handleClickShowPassword}
                                onMouseDown={handleMouseDownPassword}
                                edge="end"
                                size="medium"
                            >
                                {showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
                            </IconButton>
                        </InputAdornment>
                    )
                }}
            />
        </FormControl>
    );
};

export default Password;
